/**
 * @ Author: DY
 * @ Date: 2025-02-11 11:52:47
 * @ LastEditTime: 2025-02-11 11:52:50
 * @ Description: 
 * @ FilePath: \ShiMo_Mobile\src\assets\js\systemHome.js
 */
export const menuList = [{
    name: '销售管理系统',
    class: 'xsglxt',
    code: 'sm_xsgl',
    icon: 'icon_xsgl',
    alreadyOnline: true,
}, {
    name: '采购管理系统',
    class: 'cgglxt',
    code: 'sm_cggl',
    icon: 'icon_cggl',
    alreadyOnline: true,
}, {
    name: '运输管理系统',
    class: 'ysglxt',
    code: 'sm_ysgl',
    icon: 'icon_ysgl',
    alreadyOnline: true,
}, {
    name: '仓储管理系统',
    class: 'ccglxt',
    code: 'sm_ccgl',
    icon: 'icon_ccgl',
    alreadyOnline: true,
}, {
    name: '技术质量管理系统',
    code: 'sm_jszlglxt',
    icon: 'icon_jszlgl',
    alreadyOnline: true,
}, {
    name: '决策支持系统',
    code: 'jczcxt',
    icon: 'icon_jczc',
    alreadyOnline: true,
}, {
    name: '仓库管理系统',
    code: 'sm_ckgl',
    icon: 'icon_ckgl',
    alreadyOnline: true,
}, {
    name: '报表系统',
    code: 'sm_bbxt',
    icon: 'icon_bb',
    alreadyOnline: true,
}, {
    name: '人力资源系统',
    code: 'rlzyxt',
    icon: 'icon_rlzy',
    alreadyOnline: true,
}, {
    name: 'OA系统',
    code: 'oaxt',
    icon: 'icon_oa',
    alreadyOnline: true,
}, {
    name: '安全管理系统',
    code: 'aqglxt',
    icon: 'icon_aqgl',
    alreadyOnline: true,
}, {
    name: '财务系统',
    code: 'cwxt',
    icon: 'icon_cw',
    alreadyOnline: true,
}];